import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const FilesIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M3.5 5.4a.9.9 0 0 1 .9-.9h9.178a1 1 0 0 1 .717.3l2.922 3.006a1 1 0 0 1 .283.7V20.6a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V5.4Z"
            />
            <path
                stroke="currentColor"
                d="M5.5 4.5V3.4a.9.9 0 0 1 .9-.9h9.178a1 1 0 0 1 .722.3l2.922 3.006a1 1 0 0 1 .283.7V18.6a.9.9 0 0 1-.9.9H17.5"
            />
        </svg>
    </IconWrapper>
)
